import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { ToastService } from "ng-uikit-pro-standard";
import { SharedDataService } from "../shared-data.service";
import { DataService } from "../data.service";
import { domain } from "process";

interface Folder {
  id: any;
  name: string;
  modifiedby: any;
  modifieddate: any;
  createdby: any;
  createddate: any;
  parentId: any | null;
  // Add more properties as needed
}

@Component({
  selector: "app-folder",
  templateUrl: "./folder.component.html",
  styleUrls: ["./folder.component.scss"],
})
export class FolderComponent implements OnInit {
  isLoading = false;
  isError = false;
  errorMessage = "";
  // folders = [];
  displayedColumns: string[] = [
    "name",
    "createdby",
    "createddate",
    "modifiedby",
    "modifieddate",
  ];
  dataSource: Folder[] = [];
  currentFolderId: number | null = null;
  folders: Folder[] = [];
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private sharedDataService: SharedDataService,
    private dataService: DataService
  ) {}

  ngOnInit() {
    // this.sharedDataService.getDataSource().subscribe((data) => {
    //   this.dataSource = data;
    // });

    this.sharedDataService.newFolder$.subscribe((newFolder) => {
      if (newFolder) {
        // Update the data source with the new folder
        this.dataSource.push(newFolder);
      }
    });
    this.route.queryParams.subscribe((params) => {
      const parentId = params["parentId"];
      if (parentId) {
        this.getFolder(parentId);
      } else {
        // If parentId is not provided, fetch top-level folders
        this.getFolder(null);
      }
    });

    // this.dataSource = this.folders.filter((folder) => folder.parentId === null);

    // this.getFolder();
  }

  navigateToFolder(parentFolderId: string) {
    this.router.navigate(["/home/folder"], {
      queryParams: { parentId: parentFolderId },
    });
  }

  navigateToFolders(parentFolderId: string , parentFolderName: string) {
    this.router.navigateByUrl("/home/folder/sub/" + parentFolderId + '/'+ parentFolderName);
  }

  handleFolderClick(folder: Folder) {
    // Update current folder id
    this.currentFolderId = folder.id;
    // Update data source to show contents of clicked folder
    this.dataSource = this.folders.filter(
      (folder) => folder.parentId === this.currentFolderId
    );
  }

  // handleFolderClick(folderId: any) {
  //   // Clear the dataSource array
  //   this.dataSource = [];

  //   // Perform any other actions related to clicking the folder name, such as navigation
  //   this.router.navigate(['/home/folder/edit', folderId]);
  // }
  navigateToNewFolder(parentFolderId: string) {
    this.router.navigate(["/create-folder"], {
      queryParams: { parentId: parentFolderId },
    });
  }

  getFolder(parentId: string) {
    // alert(id)
    const organizationid = localStorage.getItem("crm_orgid");
    // const domain = localStorage.getItem("domain");
    // const subdomain = localStorage.getItem("subdomain");
     const domain= localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`);
    const subdomain= localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`);

    this.isLoading = true;
    this.dataService.getFolders(organizationid,domain,subdomain).subscribe(
      (res) => {
        // alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          // alert("Are you sure?")
          // this.router.navigate(['home/globalaction'])
          // window.location.reload();
          // this.folders = res.data.folder;
            this.folders = res.data.folder.filter(folder => folder.parentfolderid == 'undefined');

          if (this.folders != null) {
            this.dataSource = this.folders.map((folder) => ({
              id: folder.id,
              name: folder.name,
              modifiedby: folder.modifiedby,
              modifieddate: folder.modifieddate,
              createdby: folder.createdby,
              createddate: folder.createddate,
              parentId: null,
            }));
          }
          this.isLoading = false;
        } else {
          console.log("error in getting data");
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
}
